Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _crossFetch = require('cross-fetch');

var _crossFetch2 = _interopRequireDefault(_crossFetch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var fetchGraphQL = function fetchGraphQL(requestOptions) {
  var graphQLUrl = requestOptions.graphQLUrl,
      url = requestOptions.url,
      credentials = requestOptions.credentials,
      app = requestOptions.app,
      query = requestOptions.query,
      headers = requestOptions.headers;
  var fetchUrl = credentials ? url.replace('//', '//' + credentials + '@') : url;
  return (0, _crossFetch2.default)(graphQLUrl, {
    method: 'POST',
    body: '\n\t\t\tquery{\n\t\t\t\telastic77(host: "' + fetchUrl + '"){\n\t\t\t\t\tmsearch(\n\t\t\t\t\t\tindex: "' + app + '"\n\t\t\t\t\t\tbody: ' + JSON.stringify(query.map(function (item) {
      return JSON.stringify(item);
    })) + '\n\t\t\t\t\t)\n\t\t\t\t}\n\t\t\t}\n\t\t',
    headers: _extends({}, headers, {
      'Content-Type': 'application/graphql'
    })
  }).then(function (res) {
    return res.json();
  }).then(function (jsonRes) {
    return jsonRes.data.elastic77.msearch;
  }).catch(function (error) {
    console.error(error);
  });
};

exports.default = fetchGraphQL;